import { useState } from 'react';

// Per-column pixel widths (keyed by dataKey) for a resizable rsuite Table.
// rsuite's column resize only works on a fixed `width` (a flexGrow column's
// resize base is 0), so resizable columns pass `width={colWidth(key)}` and
// `onResize={onColumnResize}`. Widths are held in state so a drag persists
// across sort/filter/refresh re-renders (rsuite otherwise resets to the passed
// width prop). `colWidth(key)` falls back to `defaults[key]` until resized.
//
// The dataKey rsuite hands to onResize is the *<Cell>* child's dataKey, NOT a
// Column-level prop (rsuite-table's useCellDescriptor derives it from
// cell.props.dataKey, and a Column dataKey would be overridden by it) — so each
// resizable column's <Cell dataKey="..."> must match the colWidth(key) it uses.
export function useColumnWidths(defaults) {
  const [widths, setWidths] = useState({});
  const onColumnResize = (width, dataKey) => setWidths((prev) => ({ ...prev, [dataKey]: width }));
  const colWidth = (key) => widths[key] ?? defaults[key];
  return { colWidth, onColumnResize };
}
